import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context8, _context9; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context8 = ownKeys(Object(t), !0)).call(_context8, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context9 = ownKeys(Object(t))).call(_context9, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import * as React from "react";
import { IconConstants, makeStyles } from "componentLibrary";
import { Icon, RaiseColors, Typography } from "components/mui";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    container: {
      flexDirection: "column",
      display: "flex",
      gap: "8px"
    },
    draggableRow: {
      border: "1px solid ".concat(RaiseColors.neutral300),
      background: RaiseColors.neutral200,
      padding: "8px 16px 8px 8px",
      display: "flex",
      alignItems: "center",
      borderRadius: "4px"
    },
    dragIcon: {
      marginRight: "8px"
    },
    rowContent: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    },
    removeIcon: {
      cursor: "pointer"
    }
  };
});
export default function DragDropSortableFields(_ref) {
  var data = _ref.data,
    onChange = _ref.onChange,
    name = _ref.name,
    useRedesign = _ref.useRedesign,
    renderRow = _ref.renderRow,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var classes = useStyles();
  var createOnStopChange = function createOnStopChange(index) {
    return function (event) {
      var _context;
      var changedStop = _objectSpread(_objectSpread({}, data[index]), {}, _defineProperty({}, event.target.name, event.target.value));
      onChange({
        target: {
          name: name,
          value: _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_sliceInstanceProperty(data).call(data, 0, index)), [changedStop], _toConsumableArray(_sliceInstanceProperty(data).call(data, index + 1)))
        }
      });
    };
  };
  var createOnRemove = function createOnRemove(index) {
    return function () {
      var _context2;
      onChange({
        target: {
          name: name,
          value: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(_sliceInstanceProperty(data).call(data, 0, index)), _toConsumableArray(_sliceInstanceProperty(data).call(data, index + 1)))
        }
      });
    };
  };
  var onDragEnd = function onDragEnd(result) {
    var _context3, _context4, _context5;
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    var sourceIndex = result.source.index;
    var destIndex = result.destination.index;
    var itemDragged = data[sourceIndex];
    var itemAtDestination = data[destIndex];

    // Prevent dragging to positions occupied by disabled items
    if (itemAtDestination.isDisabled) {
      return;
    }

    // when dragging down the list, the item currently at destIndex (not the item being dragged)
    // needs to be added to the itemsBefore array
    if (sourceIndex < destIndex) {
      destIndex += 1;
    }
    var itemsBefore = _filterInstanceProperty(_context3 = _sliceInstanceProperty(data).call(data, 0, destIndex)).call(_context3, function (i) {
      return i !== itemDragged;
    });
    var itemsAfter = _filterInstanceProperty(_context4 = _sliceInstanceProperty(data).call(data, destIndex)).call(_context4, function (i) {
      return i !== itemDragged;
    });
    onChange({
      target: {
        name: name,
        value: _concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(itemsBefore), [itemDragged], _toConsumableArray(itemsAfter))
      }
    });
  };
  if (disabled) {
    return /*#__PURE__*/_jsx("div", {
      className: classes.container,
      children: _mapInstanceProperty(data).call(data, function (t, i) {
        return /*#__PURE__*/_jsx(DraggableRow, {
          item: t,
          index: i,
          allFieldsDisabled: disabled,
          useRedesign: useRedesign,
          renderRow: renderRow
        });
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(DragDropContext, {
      onDragEnd: onDragEnd,
      children: /*#__PURE__*/_jsx(Droppable, {
        droppableId: "droppable",
        children: function children(provided) {
          return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
            ref: provided.innerRef
          }, provided.droppableProps), {}, {
            className: classes.container,
            children: [_mapInstanceProperty(data).call(data, function (t, i) {
              var _t$isDisabled;
              return /*#__PURE__*/_jsx(Draggable, {
                draggableId: getDraggableId(t, i),
                index: i,
                isDragDisabled: (_t$isDisabled = t === null || t === void 0 ? void 0 : t.isDisabled) !== null && _t$isDisabled !== void 0 ? _t$isDisabled : false,
                children: function children(provided) {
                  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
                    ref: provided.innerRef
                  }, provided.draggableProps), {}, {
                    style: provided.draggableProps.style,
                    children: /*#__PURE__*/_jsx(DraggableRow, {
                      item: t,
                      index: i,
                      onChange: createOnStopChange(i),
                      onRemove: createOnRemove(i),
                      dragHandleProps: provided.dragHandleProps,
                      renderRow: renderRow,
                      useRedesign: useRedesign
                    })
                  }));
                }
              }, getDraggableId(t, i));
            }), provided.placeholder]
          }));
        }
      })
    })
  });
}
function getDraggableId(tourStop, index) {
  // react-beautiful-dnd expects the id to be a string
  return "".concat(index);
}
var DraggableRow = function DraggableRow(_ref2) {
  var _context6, _context7;
  var item = _ref2.item,
    onRemove = _ref2.onRemove,
    dragHandleProps = _ref2.dragHandleProps,
    onChange = _ref2.onChange,
    index = _ref2.index,
    useRedesign = _ref2.useRedesign,
    renderRow = _ref2.renderRow,
    _ref2$allFieldsDisabl = _ref2.allFieldsDisabled,
    allFieldsDisabled = _ref2$allFieldsDisabl === void 0 ? false : _ref2$allFieldsDisabl;
  var classes = useStyles();
  var isRemovable = useRedesign ? item === null || item === void 0 ? void 0 : item.isRemovable : !item.isDisabled;
  return /*#__PURE__*/_jsxs("div", {
    className: classes.draggableRow,
    children: [!(item !== null && item !== void 0 && item.isDisabled) && /*#__PURE__*/_jsx(Icon, _objectSpread({
      className: _concatInstanceProperty(_context6 = "".concat(IconConstants.DOTS_SIX, " ")).call(_context6, classes.dragIcon),
      fontSize: 20
    }, dragHandleProps)), /*#__PURE__*/_jsx("div", {
      className: classes.rowContent,
      children: renderRow ? renderRow(item, index) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph_small",
          weight: "medium",
          color: allFieldsDisabled ? RaiseColors.grayscale900 : RaiseColors.glacier2400,
          children: item === null || item === void 0 ? void 0 : item.label
        }), isRemovable ? /*#__PURE__*/_jsx(Icon, {
          fontSize: 14,
          className: _concatInstanceProperty(_context7 = "".concat(IconConstants.X, " ")).call(_context7, classes.removeIcon),
          onClick: onRemove
        }) : null]
      })
    })]
  });
};